import {
  Box,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  AutoCompleteController,
  CustomDialog,
  Table,
} from '../../../components';
import { TFieldReport } from '../../../types/mvpCharts';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useFormWithSchema } from '../../../utils/functions/yupFormTypescript';
import * as yup from 'yup';
import LaunchIcon from '@mui/icons-material/Launch';
import EditIcon from '@mui/icons-material/Edit';
import {
  createSearchParams,
  useNavigate,
} from 'react-router-dom';
// import { SideSheet } from './sideSheet';
import {
  useGetReportRequestsQuery,
  useLazyGetAllEmployeesQuery,
  useInsertOrUpdateRequestInspectionMutation,
} from '../../../services/mVPGraphQlService';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import nodatafound from '../../../assets/images/nodatafound.png';
import { showAlert } from '../../../services/alert';
import ResponsiveCard from '../../../components/card';
import { Pagination } from '@mui/material';
import { AutoCompleteControllerV2 } from '../../../components/autoCompletev2';
import React from 'react';
import { useFilterContext } from '../../../services/mVPMapService/filterContext';

type applyFilterProps = {
  type: string;
  setRequestedCount: any;
  setReceivedCount: any;
  onNavigate?: (tabId: string, props?: any) => void; // 👈 add this
};

export const MVPDataTableInternal: React.FC<
  applyFilterProps
> = ({
  type,
  setRequestedCount,
  setReceivedCount,
  onNavigate,
}) => {
  const formSchemaModal = yup.object({
    typeofuser: yup.string().required('Type is required'),
    name: yup.string().required('Name is required'),
    assignee: yup.string().default('All'),
  });
  const { filterValues: commonFilters } =
    useFilterContext();
  const { handleSubmit, control, watch, reset } =
    useFormWithSchema(formSchemaModal, {
      mode: 'onTouched',
    });
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [pageNo, setPageNo] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [tableData, setTableData] = useState<
    TFieldReport[]
  >([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [allTableData, setAllTableData] = useState<
    TFieldReport[]
  >([]);

  const user = useSelector(
    (state: RootState) => state.authUser
  );
  const wsId = useSelector(
    (state: RootState) => state.country.wsId
  );
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(
    window.innerWidth < 1024
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobileOrTablet(window.innerWidth < 1024);
    };

    window.addEventListener('resize', handleResize);
    return () =>
      window.removeEventListener('resize', handleResize);
  }, []);

  const queryParams = {
    reportStatus:
      type === 'REQUESTED'
        ? 'REPORT_REQUESTED'
        : 'REPORT_RECEIVED',
    pageSize: pageSize,
    pageNumber: isMobileOrTablet ? page : pageNo + 1,
    wsId: wsId,
  };

  if (watch('assignee') === 'Me' || user?.role === 'FA') {
    queryParams.actor = {
      actorId: user?.userId,
      actorName: user?.userName,
      actorType: user?.role,
    };
  }

  const { data: getTableData, refetch } =
    useGetReportRequestsQuery(queryParams, {
      refetchOnMountOrArgChange: true,
    });

  const { data: requestedData } = useGetReportRequestsQuery(
    watch('assignee') === 'Me' || user?.role === 'FA'
      ? {
          reportStatus: 'REPORT_REQUESTED',
          pageSize: 1,
          pageNumber: 1,
          wsId: wsId,
          actor: {
            actorId: user?.userId,
            actorName: user?.userName ?? '',
            actorType: user?.role,
          },
        }
      : {
          reportStatus: 'REPORT_REQUESTED',
          pageSize: 1,
          pageNumber: 1,
          wsId: wsId,
        }
  );

  const { data: receivedData } = useGetReportRequestsQuery(
    user?.role === 'FA'
      ? {
          reportStatus: 'REPORT_RECEIVED',
          pageSize: 1,
          pageNumber: 1,
          wsId: wsId,
          actor: {
            actorId: user?.userId,
            actorName: user?.userName ?? '',
            actorType: user?.role,
          },
        }
      : {
          reportStatus: 'REPORT_RECEIVED',
          pageSize: 1,
          pageNumber: 1,
          wsId: wsId,
        }
  );
  useEffect(() => {
    const requestedCount =
      requestedData?.data?.GetReportRequests?.totalCount ||
      0;
    const receivedCount =
      receivedData?.data?.GetReportRequests?.totalCount ||
      0;

    setRequestedCount(requestedCount);
    setReceivedCount(receivedCount);
  }, [requestedData, receivedData]);

  useEffect(() => {
    if (
      getTableData?.data?.GetReportRequests
        ?.reportInspections
    ) {
      setTableData(
        getTableData?.data?.GetReportRequests
          ?.reportInspections
      );
      setTotalCount(
        getTableData?.data?.GetReportRequests?.totalCount ||
          0
      );
      setAllTableData(
        getTableData?.data?.GetReportRequests
          ?.reportInspections
      );
    }
  }, [getTableData]);

  const typeList = [
    { label: 'REGION_MANAGER', value: 'REGION_MANAGER' },
    { label: 'FA', value: 'FA' },
    { label: 'TPM', value: 'TPM' },
  ];

  const assigneeList = [
    { label: 'All', value: 'All' },
    { label: 'Me', value: 'Me' },
  ];
  type Column<T, K extends keyof T> = {
    key: K;
    label: string;
    cellModifier?: (data: T) => React.ReactNode | string;
  };
  const navigate = useNavigate();
  const columns: Column<
    TFieldReport,
    keyof TFieldReport
  >[] = [
    {
      key: 'fieldNo',
      label: 'Field Number',
      cellModifier: (data) => {
        return actionNode(data?.fieldNo);
      },
    },

    {
      key: 'createdTime',
      label: 'Requested on',
      cellModifier(data) {
        return dayjs(
          data?.createdTime?.seconds
            ? data?.createdTime?.seconds * 1000
            : 0
        ).format('DD/MM/YYYY');
      },
    },
    {
      key: 'createdActor',
      label: 'Requested by',
      cellModifier(data) {
        return data?.createdActor?.actorName;
      },
    },
    {
      key: 'geography',
      label: 'Region',
      cellModifier(data) {
        return data?.geography?.region;
      },
    },
    {
      key: 'geography',
      label: 'Village',
      cellModifier(data) {
        return data?.geography?.village;
      },
    },
    {
      key: 'assigneeActor',
      label: 'Assignee',
      cellModifier: (data) => {
        return type === 'REQUESTED' && user?.role !== 'FA'
          ? assigneeNode(data)
          : data?.assigneeActor?.actorName;
      },
    },

    {
      key: 'people',
      label: 'Regional manager',
      cellModifier: (data) => {
        return data?.people?.regionManager;
      },
    },
    {
      key: 'people',
      label: 'FA',
      cellModifier: (data) => {
        return data?.people?.fa;
      },
    },
    {
      key: 'sowingTime',
      label: 'Sowing Date',
      cellModifier: (data) => {
        return data?.sowingTime?.seconds > 0
          ? dayjs(
              data?.sowingTime?.seconds
                ? data?.sowingTime?.seconds * 1000
                : 0
            ).format('DD/MM/YYYY')
          : '-';
      },
    },
    {
      key:
        type === 'REQUESTED' ? 'instructions' : 'feedback',
      label:
        type === 'REQUESTED' ? 'Instructions' : 'Feedback',
      cellModifier: (data) => {
        const text =
          type === 'REQUESTED'
            ? data?.instructions
            : data?.feedback;
        return text?.length > 20
          ? `${text.slice(0, 20)}...`
          : text;
      },
    },
  ];

  const actionNode = (tableRowData: number) => {
    const handleNavigation = () => {
      localStorage.setItem(
        'fieldId',
        tableRowData.toString()
      );
      localStorage.setItem(
        'filterIndex',
        JSON?.stringify(commonFilters)
      );

      onNavigate?.('timeseries', {
        fieldId: tableRowData.toString(),
      });
    };
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between">
        <Typography fontSize={13} fontWeight={600}>
          {tableRowData}
        </Typography>
        <Tooltip title="View field" arrow>
          <IconButton
            className="close-icon-btn"
            type="button"
            onClick={() => handleNavigation()}>
            <LaunchIcon className="close-icon" />
          </IconButton>
        </Tooltip>
      </Box>
    );
  };
  const [hoveredRow, setHoveredRow] = useState<
    number | null
  >(null);

  const assigneeNode = (tableRowData: TFieldReport) => {
    return (
      <>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          onMouseEnter={() =>
            setHoveredRow(tableRowData?.fieldNo)
          }
          onMouseLeave={() => setHoveredRow(null)}>
          <Typography fontSize={13} fontWeight={600}>
            {tableRowData?.assigneeActor?.actorName}
          </Typography>

          {hoveredRow === tableRowData?.fieldNo && (
            <IconButton
              className="close-icon-btn"
              type="button"
              onClick={() =>
                handleOpenDialog(tableRowData)
              }>
              <EditIcon className="close-icon" />
            </IconButton>
          )}
        </Box>
        {/* )} */}
      </>
    );
  };

  const handlePageChange = (
    event: React.MouseEvent | null,
    newPageNumber: number
  ) => {
    setPageNo(newPageNumber);
    setTableData(
      getPaginatedData(
        newPageNumber,
        pageSize,
        allTableData
      )
    );
  };

  const getPaginatedData = (
    newPageNumber: number,
    itemsPerPage: number,
    allItemsList: TFieldReport[]
  ) => {
    const indexOfLastItem =
      (newPageNumber + 1) * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentPageItems = allItemsList?.slice(
      indexOfFirstItem,
      indexOfLastItem
    );
    return [...currentPageItems];
  };

  const [selectedField, setSelectedField] =
    useState<TFieldReport | null>(null);

  const [allemp, { data: employees }] =
    useLazyGetAllEmployeesQuery();
  const typeofuser = watch('typeofuser');

  useEffect(() => {
    if (typeofuser) {
      allemp({ empType: typeofuser });
    }
  }, [typeofuser]);

  const formattedList =
    employees?.data?.GetAllEmployees.employees?.map(
      (item) => ({
        label: item?.actor?.actorName,
        value: item?.actor?.actorId,
        type: item?.isUser ? 'internal' : 'external',
      })
    );

  const handleOpenDialog = (field: TFieldReport) => {
    setSelectedField(field);
    setOpen(true);
  };

  const [insertOrUpdateRequest] =
    useInsertOrUpdateRequestInspectionMutation();

  const onSubmit = (data) => {
    const payload = {
      ...data,
      selectedField,
    };

    const selectedUser = formattedList?.find(
      (user) => user.value == data.name
    );

    const obj = {
      fieldNumbers: payload.selectedField.fieldNo,
      reqInstructions: payload.selectedField.instructions,
      assignee: {
        actorId: selectedUser?.value,
        actorName: selectedUser?.label,
        actorType: payload.typeofuser,
      },
      actor: {
        actorId: user?.userId,
        actorName: user?.userName,
        actorType: user?.role,
      },
      wsId: wsId,
    };

    insertOrUpdateRequest(obj)
      .unwrap()
      .then((response) => {
        const inspectionData =
          response?.data?.InsertOrUpdateRequestInspection;

        if (
          inspectionData?.responseStatus?.status ===
          'SUCCESS'
        ) {
          if (inspectionData.updatedInspectionsCount > 0) {
            dispatch(
              showAlert({
                content: `${inspectionData.updatedInspectionsCount} inspection requests updated successfully`,
                severity: 'success',
              })
            );
            reset();
            refetch();
          }

          if (inspectionData?.errorList?.length > 0) {
            inspectionData.errorList.forEach((element) => {
              dispatch(
                showAlert({
                  content: element.errorMessage,
                  severity: 'error',
                })
              );
            });
          }
        } else {
          dispatch(
            showAlert({
              content: 'Something went wrong',
              severity: 'error',
            })
          );
        }
      })

      .catch((err) => {
        console.error('Error:', err);
        dispatch(
          showAlert({
            content: 'something went wrong2',
            severity: 'error',
          })
        );
      });
  };

  const [selectedRowIds, setSelectedRowIds] = useState<
    number[]
  >([]);
  console.log(selectedRowIds);
  const handleSelectionChange = (ids: number[]) => {
    setSelectedRowIds(ids);
  };
  // const [sideSheetOpen, setSideSheetOpen] = useState(false);

  // const openSideSheet = (data: TFieldReport) => {
  //   setSelectedField(data);
  //   setSideSheetOpen(true);
  // };

  // const closeSideSheet = () => {
  //   setSideSheetOpen(false);
  // };

  const handleChange = (_event: any, value: number) => {
    setPage(value);
    setTableData(
      getPaginatedData(value, pageSize, allTableData)
    );
  };

  return isMobileOrTablet ? (
    <div>
      <div style={{ width: '200px', marginLeft: 5 }}>
        {type == 'REQUESTED' && user?.role !== 'FA' && (
          <AutoCompleteController
            control={control}
            name="assignee"
            label="Assignee"
            placeholder="Select Assignee"
            options={assigneeList}
            disableClearable
          />
        )}
      </div>
      {tableData?.length > 0 ? (
        tableData?.map((element) => (
          <ResponsiveCard
            key={element.fieldNo}
            number={element.fieldNo || 0}
            date={element.sowingTime.seconds || 0}
            region={(
              element.geography.village || 'N/A'
            ).toString()}
            details={(type && type === 'REQUESTED'
              ? element?.instructions ?? ''
              : element?.feedback ?? ''
            ).toString()}
            type={type}
            onViewDetails={() =>
              navigate({
                pathname: '/mvp/reportDetails',
                search: createSearchParams({
                  fieldId: element.fieldNo.toString(),
                  type: type,
                }).toString(),
              })
            }
          />
        ))
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '90vh',
            width: '90vw',
            margin: 'auto',
            padding: '2vw',
          }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '3vw',
              border: '2px solid rgba(229, 229, 229, 1)',
              borderRadius: '8px',
              width: '100%',
              height: '100%',
            }}>
            <img
              src={nodatafound}
              alt="No Data Found"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
            />
          </div>
        </div>
      )}
      {tableData?.length > 0 && (
        <Pagination
          count={Math.ceil(totalCount / pageSize)}
          page={page}
          onChange={handleChange}
          color="primary"
          siblingCount={1}
          boundaryCount={1}
          size="small"
          style={{
            marginTop: 20,
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      )}
    </div>
  ) : (
    <div>
      <div style={{ width: '200px' }}>
        {type == 'REQUESTED' && user?.role !== 'FA' && (
          <AutoCompleteController
            control={control}
            name="assignee"
            label="Assignee"
            placeholder="Select Assignee"
            options={assigneeList}
            disableClearable
          />
        )}
      </div>
      {tableData?.length > 0 ? (
        <Box>
          <Table
            columns={columns}
            data={tableData?.length ? tableData : []}
            rowsPerPage={pageSize}
            rowKey={'fieldNo'}
            setRowsPerPage={setPageSize}
            count={totalCount}
            page={pageNo}
            setPage={setPageNo}
            isLoading={false}
            rowsPerPageOptions={[pageSize]}
            pageChangeHandler={handlePageChange}
            onSelectionChange={handleSelectionChange}
          />
          {/* <SideSheet
            fieldId={selectedField?.fieldNo || 0}
            open={sideSheetOpen}
            onClose={closeSideSheet}
          /> */}
          <CustomDialog
            dialogTitle={'Reassign'}
            open={open}
            setOpen={setOpen}
            onSubmit={handleSubmit((data) =>
              onSubmit(data)
            )}
            actionText={{
              submit: 'Save',
              cancel: 'Cancel',
            }}
            disableAccept={!watch('name')}
            maxWidth="sm">
            <form
              onSubmit={handleSubmit((data) =>
                onSubmit(data)
              )}
              className="mb-10 pb-20">
              <AutoCompleteController
                control={control}
                name="typeofuser"
                label="Role"
                placeholder="Role"
                options={typeList}
              />
              <AutoCompleteControllerV2
                control={control}
                name="name"
                label="Assignee"
                placeholder="Assignee"
                options={formattedList}
              />
            </form>
          </CustomDialog>
        </Box>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '90vh', // Keeps it centered but uses more space
            width: '95vw', // Keeps border close to screen edges
            margin: 'auto', // Centers horizontally
            padding: '2vw', // Adjust padding dynamically
          }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '3vw', // Responsive padding
              border: '2px solid rgba(229, 229, 229, 1)', // Slightly thicker border for visibility
              borderRadius: '8px',
              width: '100%', // Makes sure it spans close to the edges
              height: '100%', // Adjusts dynamically
            }}>
            <img
              src={nodatafound}
              alt="No Data Found"
              style={{
                maxWidth: '100%', // Prevents overflow
                maxHeight: '100%', // Maintains aspect ratio
                objectFit: 'contain',
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};
